// --------------------------------------------------------------
// Created On: 2025-11-06
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Attempt to load initial state from local storage.
let initialToken = null;
const localStorageToken = localStorage.getItem("reduxSessionToken");
if (localStorageToken !== "") {
  initialToken = localStorageToken;
}

const initialState: string | null = initialToken;

// A Redux slice for the session token that is passed to the backend.
const sessionTokenSlice = createSlice({
  name: "sessionToken",
  initialState,
  reducers: {
    setSessionToken: (state, action: PayloadAction<string | null>) => {
      localStorage.setItem("reduxSessionToken", action.payload ?? "");
      return action.payload;
    },
  },
});

export const { setSessionToken } = sessionTokenSlice.actions;
export default sessionTokenSlice.reducer;
